import React, { useEffect, useState } from 'react';
import { Col, message, Row } from 'antd';
import { Icon } from 'pepsico-ds'
import MultiSelectDropdown from '../Dropdown/MultiSelectDropdown';
import SingleSelectDropdown from '../Dropdown/SingleSelectDropdown';
import { useDispatch, useSelector } from 'react-redux';
import { appNames } from '../../constants/appNames'
import { setKeyValue } from "../../redux/reducer/localDataSlice";
import { localStoreKeys } from '../../constants/localStoreKeys';
import { getBusinessUnitsBySector, getCategoriesBySectorAndBusinessUnit, getCategoriesLevel1, getSectorsForResilience, 
    getCategoriesLevel2, getRoles, formatUserDataForVendorListApi, getCategoriesL0ForSPM, getCategoriesL1ForSPM, 
    getCategoriesL2ForSPM, getCategoriesL2ForSmartcube, getCategoriesL1ForSmartcube, 
    getSectorsForSupplierFilters, getBUsForSupplierFilters, getCategoriesL0ForSupplierFilters,
    getCategoriesL1ForSupplierFilters, getCategoriesL2ForSupplierFilters, getRegenTypesForSupplierFilters, getAllRegenTypeSuppliersForSupplierFilters, getSuppliersUsingTypesForSupplierFilters, changeFromDateOptionsUtil, changeToDateOptionsUtil  } from '../../pages/KPIOverview/KpiUtils'
import { getToDateOptions, formatIntoDropdownData, getMonthsWithYearRangeAdjustedForMaxDate, getToDateOptionsWithMaxDate, getMonthsWithYearWithMaxDate, getOverlappingOptions } from '../../utils/utils';
import { FetchResiliencDropdownFiltersAction, FetchResiliencFilterAction, FetchResilincDetailAction, FetchResilincFilterAction } from '../../redux/action/SupplierRislAction';
import { FetchSPMDropdownDetails, FetchSPMSupplierDetails, FetchSupplierPerfInhouseDetail } from "../../redux/action/SupplierPerfAction"
import { FetchSustainabilityDropdownDetailsAction, FetchSustainabilitySupplierDetails, FetchSustainabilityAction } from '../../redux/action/SustainabilityAction'
import { allCategoryL0 } from '../../mocks/userJson.js';
import { FetchArchletDropdownAction } from '../../redux/action/ContractAction'
import reset_icon from "../../../src/assets/reset_icon.svg";
import InfoIcon from "../Icons/InfoIcon.js";
import { useToast } from '../../components/Toast/ToastContext';
import { batch } from 'react-redux';


const defaultYear = window.YEAR
function FilterWithSuppliers({ modalName, selectedYear, capability, userData, onParentCallback = () => { }, landingPageFilters, setLoader, appName = "", getSelectedYear, selectedTab=-1 }) {
    const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    const dispatch = useDispatch()
    const [apiLoader, setApiLoader] = useState(true)
    const [roleSelected, setRoleSelected] = useState([])
    const [sectorSelected, setSectorSelected] = useState([])
    const [businessUnitSelected, setBusinessUnitSelected] = useState([])
    const [categoryL0Selected, setCategoryL0Selected] = useState([])
    const [categoryL1Selected, setCategoryL1Selected] = useState([])
    const [categoryL2Selected, setCategoryL2Selected] = useState([])
    const [suppliersSelected, setSuppliersSelected] = useState([])
    const [fromDateSelected, setFromDateSelected] = useState("")
    const [toDateSelected, setToDateSelected] = useState("")
    const [regenSelected, setRegenSelected] = useState([])
    const [sectors, setSectors] = useState([])
    const [businessUnits, setBusinessUnits] = useState([])
    const [categoriesLevel0, setCategoriesLevel0] = useState([])
    const [categoriesLevel1, setCategoriesLevel1] = useState([])
    const [categoriesLevel2, setCategoriesLevel2] = useState([])
    const [allRegens, setAllRegens] = useState([])
    const [allSuppliers, setAllSuppliers] = useState([])
    const [userInfoByRole, setUserInfoByRole] = useState({})
    const [spendDetailsData, setSpendDetailsData] = useState({})
    const [allRoles, setAllRoles] = useState([])
    const [fromDates, setFromDates] = useState([])
    const [toDates, setToDates] = useState([])
    const [entireMonthList, setEntireMonthList] = useState([])
    const [dropdownValues, setDropdownValues] = useState({}) 
    const [supplierDataWithTypes, setSupplierDataWithTypes] = useState([])
    const [userAccessibleSectorList, setUserAccessibleSectorList] = useState([])
    const [monthYearDate, setMonthYearDate] = useState([])
    const userAccessibleSectors = useSelector((state) => state?.localData?.data[localStoreKeys.accessibleUserSectors]);
    const maxDateForApps = useSelector((state) => state?.localData?.data[localStoreKeys.maxDateForApps]);

    const resilincDropdownFilterData = useSelector(state => state.fetchResiliencDropdownFilterReducer);
    const resilincSupplierFilterData = useSelector(state => state.fetchResilincFilterReducer);
    const fetchResilincDetailData = useSelector(state => state.fetchResilincDetailReducer);

    const spmDropdownFilterData = useSelector(state => state.getSupplierPerfVendorListReducer);
    const spmSupplierFilterData = useSelector(state => state.getSPMSupplierDetailsReducer);
    const fetchSPMDetailData = useSelector(state => state.getSupplierPerfInhouseReducer);

    
    const sustainabilityDropdownFilterData = useSelector(state => state.getSustainabilityDropdownDetailsReducer);
    const sustainabilitySupplierFilterData = useSelector(state => state.fetchSustainabilitySupplierDetailsReducer);
    const sustainabilityDetailViewData = useSelector((state) => state.getSustainabilityDetailReducer);
    const { showToast } = useToast();


    
    useEffect(() => {
        if (capability===appNames.resilinc && resilincDropdownFilterData && resilincDropdownFilterData.type === "SUCCESS_RESILIENC_DROPDOWN_FILTERS_ACTION") {
                const dropdownData = resilincDropdownFilterData;
                setDropdownValues(dropdownData)
                assignDropdownValues(dropdownData);
        }
    }, [resilincDropdownFilterData]);

    
    useEffect(() => {
        if (capability===appNames.coman && spmDropdownFilterData && spmDropdownFilterData.type === "SUCCESS_VENDOR_LIST_ACTION") {
                const dropdownData = spmDropdownFilterData;
                setDropdownValues(dropdownData)
                assignDropdownValues(dropdownData);
        }
    }, [spmDropdownFilterData]);

    
    useEffect(() => {
        if (capability===appNames.sustainability && sustainabilityDropdownFilterData && sustainabilityDropdownFilterData.type === "SUCCESS_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION") {
                const dropdownData = sustainabilityDropdownFilterData;
                setDropdownValues(dropdownData)
                assignDropdownValues(dropdownData);
        }
    }, [sustainabilityDropdownFilterData]);
    
    // useEffect(() => {
    //     return () => {
    //         dispatch({ 
    //             type: 'RESET_RESILINC_DROPDOWN_FILTER_TYPE', 
    //             payload: "RESET_RESILINC_DROPDOWN_FILTER_TYPE" 
    //         });
    //         dispatch({ 
    //             type: 'RESET_RESILINC_DETAIL_TYPE', 
    //             payload: "RESET_RESILINC_DETAIL_TYPE" 
    //         });
    //         dispatch({ 
    //             type: 'RESET_RESILINC_FILTER_TYPE', 
    //             payload: "RESET_RESILINC_FILTER_TYPE" 
    //         });
    //         dispatch({ 
    //             type: 'RESET_VENDOR_LIST_FILTER_TYPE', 
    //             payload: "RESET_VENDOR_LIST_FILTER_TYPE" 
    //         });
    //         dispatch({ 
    //             type: 'RESET_SPM_SUPPLIERS_FILTER_TYPE', 
    //             payload: "RESET_SPM_SUPPLIERS_FILTER_TYPE" 
    //         });
    //         dispatch({ 
    //             type: 'RESET_SPM_INHOUSE_TYPE', 
    //             payload: "RESET_SPM_INHOUSE_TYPE" 
    //         });
    //         dispatch({ 
    //             type: 'RESET_SUPPLIER_PERFORMACE_FILTER_TYPE', 
    //             payload: "RESET_SUPPLIER_PERFORMACE_FILTER_TYPE" 
    //         });
            
    //         dispatch({ 
    //             type: 'RESET_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION', 
    //             payload: "RESET_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION" 
    //         });
            
    //         dispatch({ 
    //             type: 'RESET_SUSTAINABILITY_SUPPLIERS_ACTION', 
    //             payload: "RESET_SUSTAINABILITY_SUPPLIERS_ACTION" 
    //         });
            
    //         dispatch({ 
    //             type: 'RESET_SUSTAINABILITY_DETAIL_VIEW_ACTION', 
    //             payload: "RESET_SUSTAINABILITY_DETAIL_VIEW_ACTION" 
    //         });
    //     };
    // }, []);

    useEffect(() => {
        const RESET_TYPES = [
            'RESET_RESILINC_DROPDOWN_FILTER_TYPE',
            'RESET_RESILINC_DETAIL_TYPE',
            'RESET_RESILINC_FILTER_TYPE',
            'RESET_VENDOR_LIST_FILTER_TYPE',
            'RESET_SPM_SUPPLIERS_FILTER_TYPE',
            'RESET_SPM_INHOUSE_TYPE',
            'RESET_SUPPLIER_PERFORMACE_FILTER_TYPE',
            'RESET_SUSTAINABILITY_DROPDOWN_FILTERS_ACTION',
            'RESET_SUSTAINABILITY_SUPPLIERS_ACTION',
            'RESET_SUSTAINABILITY_DETAIL_VIEW_ACTION'
        ];
    
        return () => {
            batch(() => {
                RESET_TYPES.forEach(type => dispatch({ type, payload: type }));
            });
        };
    }, []);

    
    useEffect(() => {
        if (capability===appNames.resilinc && resilincSupplierFilterData && resilincSupplierFilterData.type === "SUCCESS_RESILINC_FILTER_ACTION") {
                /*** Process and Select Supplier Dropdown Values ***/
                const allSuppliers = resilincSupplierFilterData?.suppliers?.map((item, index) => ({ displayText: item, id: index + 1 }))
                setAllSuppliers(allSuppliers)
                setSuppliersSelected(allSuppliers)
                localStorage.setItem('suppliersSelected_suppliers', JSON.stringify(allSuppliers))
                loadKPIData();
        }
    }, [resilincSupplierFilterData]);

    
    useEffect(() => {
        if (capability===appNames.coman && spmSupplierFilterData && spmSupplierFilterData.type === "SUCCESS_SPM_SUPPLIERS_ACTION") {
                /*** Process and Select Supplier Dropdown Values ***/
                const allSuppliers = spmSupplierFilterData?.suppliers?.map((item, index) => ({ displayText: item, id: index + 1 }))
                setAllSuppliers(allSuppliers)
                setSuppliersSelected(allSuppliers)
                localStorage.setItem('suppliersSelected_suppliers', JSON.stringify(allSuppliers))
                loadKPIData();
        }
    }, [spmSupplierFilterData]);
    
    useEffect(() => {
        if (capability===appNames.sustainability && sustainabilitySupplierFilterData && sustainabilitySupplierFilterData.type === "SUCCESS_SUSTAINABILITY_SUPPLIERS_ACTION") { 
                /*** Process and Select Supplier Dropdown Values ***/
                setSupplierDataWithTypes(sustainabilitySupplierFilterData?.regenTypes);
                assignSupplierValuesForSustainability(sustainabilitySupplierFilterData?.regenTypes);
        }
    }, [sustainabilitySupplierFilterData]);

    
    useEffect(() => {
        if(capability===appNames.resilinc) {
            const formattedData = formatUserDataForVendorListApi(userData?.details)

            const requestObjForDropdownApi = {
                // selectedL0: landingPageFilters.l0sSelected.map(i => i.displayText),
                // selectedL1: landingPageFilters.l1sSelected.map(i => i.displayText),
                // selectedSector: landingPageFilters.sectors.map(i => i.displayText ? i.displayText : i),
                // selectedBu: landingPageFilters.bus.map(i => i.displayText ? i.displayText : i),
                selectedRole: landingPageFilters.role.map(i => i.displayText)[0],
                dropdownFilterRequest: formattedData
            }
            dispatch(FetchResiliencDropdownFiltersAction(requestObjForDropdownApi));
            return;
        } else if(capability===appNames.coman) {
            const formattedData = formatUserDataForVendorListApi(userData?.details)

            const requestObjForDropdownApi = {
                selectedRole: landingPageFilters.role.map(i => i.displayText)[0],
                dropdownFilterRequest: formattedData
            }
            dispatch(FetchSPMDropdownDetails(requestObjForDropdownApi));
            return;

        } else if(capability===appNames.sustainability) {
            const formattedData = formatUserDataForVendorListApi(userData?.details)

            const requestObjForDropdownApi = {
                dropdownFilterRequest: formattedData
            }
            dispatch(FetchSustainabilityDropdownDetailsAction(requestObjForDropdownApi));
            return;

        }
    }, [userData]);

    
    useEffect(() => {
        if (fetchResilincDetailData && fetchResilincDetailData?.type === "SUCCESS_RESILINC_DETAIL_ACTION") {
            onParentCallback({ data: fetchResilincDetailData, loader: false })
        }
    }, [fetchResilincDetailData])

    
    useEffect(() => {
        if (fetchSPMDetailData && fetchSPMDetailData?.type === "SUCCESS_SPM_INHOUSE_ACTION") {
            onParentCallback({ data: fetchSPMDetailData, loader: false })
        }
    }, [fetchSPMDetailData])

    
    useEffect(() => {
        if (fetchSPMDetailData && fetchSPMDetailData?.type === "SUCCESS_SPM_INHOUSE_ACTION") {
            onParentCallback({ data: fetchSPMDetailData, loader: false })
        }
    }, [fetchSPMDetailData])

    
    useEffect(() => {
        if (sustainabilityDetailViewData && sustainabilityDetailViewData?.type === "SUCCESS_SUSTAINABILITY_DETAIL_VIEW_ACTION") {
            const regenData = JSON.parse(localStorage.getItem("regenSelected_suppliers"));  
            const suppliersData = JSON.parse(localStorage.getItem("suppliersSelected_suppliers")); 
            onParentCallback({ data: sustainabilityDetailViewData, loader: false, suppliers: suppliersData, regen: regenData })
        }
    }, [sustainabilityDetailViewData])

    
    const assignDropdownValues = (dropdownData) => {
        const Roles = getRoles(dropdownData.dropdown);
        const defaultRole = Roles.filter((item) => item.displayText === dropdownData.defaultRole);
        setAllRoles(Roles)
        const getUserInfoByRole = dropdownData?.dropdown?.filter(item => item.role === landingPageFilters?.role[0]?.displayText)?.[0]
        setUserInfoByRole(getUserInfoByRole)
        setRoleSelected(landingPageFilters?.role)


        /*** Process and Select Sector Dropdown Values ***/
        let sectorsToInclude = landingPageFilters?.sectors?.map(item => (item.displayText ? item.displayText : item))
        const sectors = getSectorsForSupplierFilters(getUserInfoByRole?.sector);
        setSectors(sectors)

        const sectorsToSelect= (getOverlappingOptions(getSectorsForSupplierFilters(getUserInfoByRole?.sector),landingPageFilters?.sectors))
        setSectorSelected(sectorsToSelect)
        localStorage.setItem("sectorSelected_suppliers", JSON.stringify(sectorsToSelect))
        const accessibleSectorsTemp = sectors?.map(item => (item.displayText))
        setUserAccessibleSectorList(accessibleSectorsTemp)



        /*** Process and Select BU Dropdown Values ***/
        let busToSelect = [];
        if(capability===appNames.resilinc) {
            const BUs = getBUsForSupplierFilters(getUserInfoByRole?.sector, sectorsToInclude);
            setBusinessUnits(BUs)
    
            busToSelect= (getOverlappingOptions(BUs,landingPageFilters?.bus, capability, "bu"))
            setBusinessUnitSelected(busToSelect)
            localStorage.setItem("BUSeleceted_suppliers", JSON.stringify(busToSelect))
        }



        /*** Process and Select Category L0, L1, L2 Dropdown Values ***/
        let categoriesL0ToInclude = landingPageFilters?.l0sSelected?.map(item => (item.displayText));
        const l0Categories = getCategoriesL0ForSupplierFilters(getUserInfoByRole?.l0);
        const l0sToSelect = (getOverlappingOptions(l0Categories,landingPageFilters?.l0sSelected))
        setCategoriesLevel0(l0Categories)
        setCategoryL0Selected(l0sToSelect)
        localStorage.setItem('CategoryL0Selected_suppliers', JSON.stringify(l0sToSelect))

        let categoriesL1ToInclude = landingPageFilters?.l1sSelected?.map(item => (item.displayText))
        let l1Categories = [];
        if(capability===appNames.sustainability) {

            l1Categories = [...new Set(getUserInfoByRole?.l1)]?.map((str, index) => ({ displayText: str, id: index + 1 }));
        }
        else {
            l1Categories = getCategoriesL1ForSupplierFilters(getUserInfoByRole?.l0,categoriesL0ToInclude)
        }
        const l1sToSelect = (getOverlappingOptions(l1Categories,landingPageFilters?.l1sSelected))
        setCategoriesLevel1(l1Categories)
        setCategoryL1Selected(l1sToSelect)
        localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify(l1sToSelect))
        

        
        const l2Categories = getCategoriesL2ForSupplierFilters(getUserInfoByRole?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
        setCategoriesLevel2(l2Categories);
        // setCategoryL2Selected(l2Categories);
        // localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify(l2Categories))
        const l2sToSelect = (getOverlappingOptions(l2Categories,landingPageFilters?.l2sSelected))
        setCategoryL2Selected(l2sToSelect);
        localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify(l2sToSelect))

        let capabilitySearchKey = (appName === "Supplier Performance") ? appName : capability;


        const minYear = atob(localStorage.getItem("minYear"));
        const maxYear = atob(localStorage.getItem("maxYear"));

        setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));
        const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

        let years = dropdownData?.year?.slice();
        
        const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
        setFromDates(fromDate);

        const yearSelected = localStorage.getItem("yearSelected");

        const date2 = new Date();
        const date2Year = date2.getFullYear();

        const fromDateMonth = capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`) ? 'Dec' : capability === appNames.compass && date2Year === Number(yearSelected) ? maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'
        
        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })
        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]); // Extracting year from maxDate
        let maxYearMonth = maxDateObject?.maxYearMonth; // Example: "OCT 2024"
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setToDates(toDateOptions);

        if (capability === appNames.sustainability) {
            setFromDateSelected(landingPageFilters.year)
            localStorage.setItem('fromDateSelected_suppliers', JSON.stringify(landingPageFilters.year))
        } else {
            setFromDateSelected(tempFromDate);
            
            localStorage.setItem('fromDateSelected_suppliers', JSON.stringify(tempFromDate))
        }
        dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: tempFromDate?.[0]?.['displayText'] }));
        setToDateSelected(tempToDate); 
        localStorage.setItem('toDateSelected_suppliers', JSON.stringify(tempToDate))
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }
        loadSuppliersData(landingPageFilters?.role, 
            sectorsToSelect, busToSelect, 
            l0sToSelect, l1sToSelect, l2Categories, 
            tempFromDate, tempToDate)
               
    }
    
    const assignSupplierValuesForSustainability = (dropdownData) => {

        const regenTypes = getRegenTypesForSupplierFilters(dropdownData);
        setAllRegens(regenTypes);
        setRegenSelected(regenTypes);
        localStorage.setItem('regenSelected_suppliers', JSON.stringify(regenTypes))

        const allSuppliers = getAllRegenTypeSuppliersForSupplierFilters(dropdownData);
        setAllSuppliers(allSuppliers);
        setSuppliersSelected(allSuppliers);
        localStorage.setItem('suppliersSelected_suppliers', JSON.stringify(allSuppliers));

        loadKPIData();

    }

    
    const onRoleChange = (val) => {
        if (val && val.length>0) {
            setLoader(true)
            setRoleSelected(val);
            let getUserInfoByRole = userData?.details?.filter(item => item.role === val[0]?.displayText)?.[0];
            if(capability===appNames.resilinc || capability===appNames.coman) {
                getUserInfoByRole = dropdownValues?.dropdown?.filter(item => item.role === val[0]?.displayText)?.[0];
            }
            setUserInfoByRole(getUserInfoByRole)



            const sectors = getSectorsForSupplierFilters(getUserInfoByRole?.sector);
            setSectors(sectors)
            setSectorSelected(sectors)
            localStorage.setItem("sectorSelected_suppliers", JSON.stringify(sectors))
            const accessibleSectorsTemp = sectors?.map(item => (item.displayText))
            setUserAccessibleSectorList(accessibleSectorsTemp)

            let sectorsToInclude = sectors?.map(item => (item.displayText ? item.displayText : item))
            const BUs = getBUsForSupplierFilters(getUserInfoByRole?.sector, sectorsToInclude);
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            localStorage.setItem("BUSeleceted_suppliers", JSON.stringify(BUs))

            /*** Process and Select Category L0, L1, L2 Dropdown Values ***/
            const l0Categories = getCategoriesL0ForSupplierFilters(getUserInfoByRole?.l0);
            let categoriesL0ToInclude = l0Categories?.map(item => (item.displayText));
            setCategoriesLevel0(l0Categories)
            setCategoryL0Selected(l0Categories)
            localStorage.setItem('CategoryL0Selected_suppliers', JSON.stringify(l0Categories))

            const l1Categories = getCategoriesL1ForSupplierFilters(getUserInfoByRole?.l0,categoriesL0ToInclude)
            let categoriesL1ToInclude = l1Categories?.map(item => (item.displayText))
            setCategoriesLevel1(l1Categories)
            setCategoryL1Selected(l1Categories)
            localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify(l1Categories))

            const l2Categories = getCategoriesL2ForSupplierFilters(getUserInfoByRole?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
            setCategoriesLevel2(l2Categories);
            setCategoryL2Selected(l2Categories);
            localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify(l2Categories))


            loadSuppliersData(val, 
                sectors, BUs, 
                l0Categories, l1Categories, l2Categories, 
                fromDateSelected, toDateSelected)
        
        }
    };

    
    const onSectorChange = (val) => {
        if (val && val.length > 0) {
            ////
            setSectorSelected(val)
            localStorage.setItem("sectorSelected_suppliers", JSON.stringify(val))
            dispatch(setKeyValue({ key: localStoreKeys.sectorSelectedOnDetail, value: val }))
            setLoader(true)

            /*** Process and Select Sector Dropdown Values ***/
            let sectorsToInclude = val?.map(item => (item.displayText ? item.displayText : item))
            const accessibleSectorsTemp = sectors?.map(item => (item.displayText))
            setUserAccessibleSectorList(accessibleSectorsTemp)


            /*** Process and Select BU Dropdown Values ***/
            const BUs = getBUsForSupplierFilters(userInfoByRole?.sector, sectorsToInclude);
            setBusinessUnits(BUs)
            setBusinessUnitSelected(BUs)
            localStorage.setItem("BUSeleceted_suppliers", JSON.stringify(BUs))


            loadSuppliersData(roleSelected, 
                val, BUs, 
                categoryL0Selected, categoryL1Selected, categoryL2Selected, 
                fromDateSelected, toDateSelected)
        } else {
            if (val && val.length === 0) {
                setBusinessUnitSelected([])
                localStorage.setItem("BUSeleceted_suppliers", JSON.stringify([]))
                message.warning("At least one sector is required")
                setSectorSelected([])
                localStorage.setItem("sectorSelected_suppliers", JSON.stringify([]))
            }
        }
    }

    
    const onBusinessUnitChange = (val) => {
        if (val && val.length > 0) {
            if (sectorSelected.length > 0) {
                setBusinessUnitSelected(val)
                localStorage.setItem("BUSeleceted_suppliers", JSON.stringify(val))
                setLoader(true)
                
                loadSuppliersData(roleSelected, 
                    sectorSelected, val, 
                    categoryL0Selected, categoryL1Selected, categoryL2Selected,
                    fromDateSelected, toDateSelected)
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                message.warning("At least one business unit / market is required")
                localStorage.setItem("BUSeleceted_suppliers", JSON.stringify([]))
                setBusinessUnitSelected([])
            }
        }
    }

    
    const onCategoryLevel0Change = (val) => {
        let sectorSelectedData = localStorage.getItem('sectorSelected_suppliers')
        sectorSelectedData = JSON.parse(sectorSelectedData)
        let businessUnitSelectedData = JSON.parse(localStorage.getItem('BUSeleceted_suppliers'))
        if (val && val.length > 0) {
            if (sectorSelectedData.length > 0) {
                if ((capability===appNames.resilinc && businessUnitSelectedData.length > 0) || (capability===appNames.coman)) {
                    setCategoryL0Selected(val)
                    localStorage.setItem('CategoryL0Selected_suppliers', JSON.stringify(val))
                    setLoader(true)
                    
                    /*** Process and Select Category L0, L1, L2 Dropdown Values ***/
                    let categoriesL0ToInclude = val?.map(item => (item.displayText));
                    const l1Categories = getCategoriesL1ForSupplierFilters(userInfoByRole?.l0,categoriesL0ToInclude)
                    setCategoriesLevel1(l1Categories)
                    setCategoryL1Selected(l1Categories)
                    localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify(l1Categories))

                    let categoriesL1ToInclude = l1Categories?.map(item => (item.displayText))
                    const l2Categories = getCategoriesL2ForSupplierFilters(userInfoByRole?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
                    setCategoriesLevel2(l2Categories);
                    setCategoryL2Selected(l2Categories);
                    localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify(l2Categories))



                    loadSuppliersData(roleSelected, 
                        sectorSelected, businessUnitSelected, 
                        val, l1Categories, l2Categories, 
                        fromDateSelected, toDateSelected)
                
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL2Selected([])
                localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify([]))
                localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify([]))
                setCategoryL1Selected([])
                localStorage.setItem('CategoryL0Selected_suppliers', JSON.stringify([]))
                setCategoryL0Selected([])
                message.warning("At least one category L0 is required")
            }
        }
    }

    
    const onCategoryLevel1Change = (val) => {
        let sectorSelectedData = localStorage.getItem('sectorSelected_suppliers')
        sectorSelectedData = JSON.parse(sectorSelectedData)
        let businessUnitSelectedData = JSON.parse(localStorage.getItem('BUSeleceted_suppliers'))
        if (val && val.length > 0) {
            if (sectorSelectedData.length > 0) {
                if ((capability===appNames.resilinc && businessUnitSelectedData.length > 0) || (capability===appNames.coman) || (capability===appNames.sustainability)) {
                    if (categoryL0Selected.length > 0 || (capability===appNames.sustainability)) {
                        setCategoryL1Selected(val)
                        localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify(val))
                        setLoader(true)
                        
                        let categoriesL0ToInclude = categoryL0Selected?.map(item => (item.displayText))
                        let categoriesL1ToInclude = val?.map(item => (item.displayText))
                        const l2Categories = getCategoriesL2ForSupplierFilters(userInfoByRole?.l0, categoriesL0ToInclude, categoriesL1ToInclude);
                        setCategoriesLevel2(l2Categories);
                        setCategoryL2Selected(l2Categories);
                        localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify(l2Categories))
                        
                    
                        loadSuppliersData(roleSelected, 
                            sectorSelected, businessUnitSelected, 
                            categoryL0Selected, val, l2Categories,
                            fromDateSelected, toDateSelected)

                    } else {
                        message.warning("Please select at least one category 0")
                    }
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                setCategoryL2Selected([])
                setCategoryL1Selected([])
                localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify([]))
                localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify([]))
                loadSuppliersData(
                    roleSelected, 
                    sectorSelected, businessUnitSelected,
                    categoryL0Selected, [], [], 
                    fromDateSelected, toDateSelected, 
                    )
                if (capability === appNames.archlet || capability === appNames.compass || capability === appNames.powersteering) {
                    message.warning("At least one category L1 is required")
                }
            }
        }
    }

    
    const onCategoryLevel2Change = (val) => {
        let sectorSelectedData = localStorage.getItem('sectorSelected_suppliers')
        sectorSelectedData = JSON.parse(sectorSelectedData)
        let businessUnitSelectedData = JSON.parse(localStorage.getItem('BUSeleceted_suppliers'))
        if (val && val.length > 0) {
            if (sectorSelectedData.length > 0) {
                if ((capability===appNames.resilinc && businessUnitSelectedData.length > 0) || (capability===appNames.coman) || (capability===appNames.sustainability)) {
                    if (categoryL0Selected.length > 0 || (capability===appNames.sustainability)) {
                        if (categoryL1Selected.length > 0 || (capability===appNames.sustainability)) {
                            setCategoryL2Selected(val)
                            localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify(val))
                            setLoader(true)
                            loadSuppliersData(
                                roleSelected, 
                                sectorSelected, businessUnitSelected, 
                                categoryL0Selected, categoryL1Selected, val, 
                                fromDateSelected, toDateSelected)
                        } else {
                            message.warning("Please select at least one category 1")
                        }
                    } else {
                        message.warning("Please select at least one category 0")
                    }
                } else {
                    message.warning("Please select at least one business unit / market")
                }
            } else {
                message.warning("Please select at least one sector")
            }
        } else {

            if (val && val.length === 0) {
                localStorage.setItem('categoryL2Selected_suppliers', JSON.stringify([]))
                setCategoryL2Selected([])
                message.warning("At least one category L2 is required")
                loadSuppliersData(
                    roleSelected, 
                    sectorSelected, businessUnitSelected, 
                    categoryL0Selected, categoryL1Selected, [], 
                    fromDateSelected, toDateSelected)
            }
        }
    }

    
    const onFromDateChange = (val) => {
        let sectorSelectedData = localStorage.getItem("sectorSelected_suppliers")
        sectorSelectedData = JSON.parse(sectorSelectedData)

        if (val && val.length > 0) {
            if (capability === appNames.sustainability) {
                    setFromDateSelected(val)
                    localStorage.setItem('fromDateSelected_suppliers', JSON.stringify(val))
                    loadKPIData();
            } else {
                    setFromDateSelected(val)
                    localStorage.setItem('fromDateSelected_suppliers', JSON.stringify(val))
                    dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: val[0]['displayText'] }));
                    const toDateOptions = getToDateOptions(val[0]['displayText']);

                    let capabilitySearchKey = (appName === "In-house MI Team") || (capability===appNames.forestreet) ? appName : capability;
                    const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);
                    const toDateOptions1 = getToDateOptionsWithMaxDate(val[0]['displayText'], maxDateObject);
                    setToDates(toDateOptions1);

                    let tempY = val[0]['displayText']?.split(" ")?.[1]
                    const date1 = new Date(val[0]['displayText']);
                    const date2 = new Date(toDateSelected?.[0]?.['displayText']);
                    const date2Year = date2?.getFullYear();
                    const toDateMonth = months[date2?.getMonth()];;

                    const tempToDate = toDateOptions1?.filter((item) => { // CHANGED
                        return item.displayText === ('Dec ' + tempY);
                    })

                    const customTempToDate = toDateOptions1?.filter((item) => { // CHANGED
                        return item.displayText === (`${toDateMonth} ` + date2Year);
                    })
                    changeToDateOptions(val[0])

                    if (!isNaN(date1.getTime()) && !isNaN(date2?.getTime())) {
                        if (date1 <= date2) {
                            setToDateSelected(customTempToDate); 
                            localStorage.setItem('toDateSelected_suppliers', JSON.stringify(customTempToDate))
                            loadKPIData();
                        } else {
                            setToDateSelected(tempToDate);
                            localStorage.setItem('toDateSelected_suppliers', JSON.stringify(tempToDate))
                            loadKPIData();
                        }
                    } else {
                        loadKPIData();
                    }
                }
            
        } else {
            message.warning("From Date is not selected")
        }
    }

    
    const onToDateChange = (val) => {
        if (val && val.length > 0) {
            setToDateSelected(val)
            localStorage.setItem('toDateSelected_suppliers', JSON.stringify(val))
            changeFromDateOptions(val[0]);
            loadKPIData();
        } else {
            message.warning("To Date is not selected")
        }
    }

    
    const onRegenChange = (val) => {
        if (val && val.length > 0) {
            setLoader(true)
            setRegenSelected(val)
            localStorage.setItem('regenSelected_suppliers', JSON.stringify(val))
            const suppliers = getSuppliersUsingTypesForSupplierFilters(supplierDataWithTypes,val.map(item=>item?.displayText))
            setAllSuppliers(suppliers)
            setSuppliersSelected(suppliers)
            localStorage.setItem('suppliersSelected_suppliers', JSON.stringify(suppliers))
            loadKPIData();
        } else {
            if (val && val.length === 0) {
                setRegenSelected([])
                localStorage.setItem('regenSelected_suppliers', JSON.stringify([]))
                setAllSuppliers([])
                setSuppliersSelected([])
                localStorage.setItem('suppliersSelected_suppliers', JSON.stringify([]))
                message.warning("At least one Regen Type is required.")
            }
        }
    }

    
    const onSupplierChange = (val) => {
        if (val && val.length > 0) {
            setLoader(true)
            setSuppliersSelected(val)
            localStorage.setItem('suppliersSelected_suppliers', JSON.stringify(val))
            loadKPIData();
        } else {
            if (val && val.length === 0) {
                setSuppliersSelected([])
                localStorage.setItem('suppliersSelected_suppliers', JSON.stringify([]))
                message.warning("At least one supplier is required.")
            }
        }
    }

    
    const changeFromDateOptions = (toDateMonthSelected) => {
        /* const toDateSelected = toDateMonthSelected.displayText;
        const maxDate = new Date(toDateSelected);
        const filteredMonths = entireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate <= maxDate;
        });
        filteredMonths.push(toDateMonthSelected);
        filteredMonths.sort((a, b) => new Date(a.value) - new Date(b.value));
		*/
		const filteredMonths = changeFromDateOptionsUtil(toDateMonthSelected,entireMonthList)
        setFromDates(filteredMonths)
    }
	
	
	
    
    const changeToDateOptions = (fromDateMonthSelected) => {
        /* const toDateSelected1 = fromDateMonthSelected.displayText;
        const fromDate = new Date(toDateSelected1);
        const filteredMonths = entireMonthList.filter((month) => {
            const monthDate = new Date(month.value);
            return monthDate >= fromDate;
        });*/
		const filteredMonths = changeToDateOptionsUtil(fromDateMonthSelected,entireMonthList)
        setToDates(filteredMonths);
    };

    
    const onFiltersReset = () => {
        let capabilitySearchKey = (appName === "Supplier Performance") ? appName : capability;
        const minYear = atob(localStorage.getItem("minYear"));
        const maxYear = atob(localStorage.getItem("maxYear"));

        setEntireMonthList(getMonthsWithYearRangeAdjustedForMaxDate(minYear, maxYear, capabilitySearchKey, maxDateForApps));
        const maxDateObject = maxDateForApps?.find(item => item.appName === capabilitySearchKey);

        let years = userData?.year?.slice();

        const fromDate = getMonthsWithYearWithMaxDate(selectedYear, maxDateObject);
        setFromDates(fromDate);

        let yearSelected = localStorage.getItem("yearSelected");
        const allYears = landingPageFilters?.allYears
        let yearVal = allYears
        if (defaultYear !== "-") {
            yearSelected = defaultYear;
            yearVal = formatIntoDropdownData([Number(defaultYear)], allYears)
        }

        const date2 = new Date();
        const date2Year = date2.getFullYear();

        const fromDateMonth = capability === appNames.compass && fromDate?.find(item => item?.displayText === `Dec ${yearSelected}`) ? 
                                    'Dec' 
                                    : capability === appNames.compass && date2Year === Number(yearSelected) ? maxDateObject?.maxYearMonth?.split(" ")?.[0] : 'Jan'
        const tempFromDate = fromDate.filter((item) => {
            return item.displayText === (fromDateMonth + ' ' + yearSelected);
        })

        let objectYear = Number(maxDateObject?.maxDate?.split("-")[0]);
        let maxYearMonth = maxDateObject?.maxYearMonth;
        let tempToDate = fromDate.filter((item) => {
            let temp = fromDate[fromDate.length - 1]?.displayText;

            let currentLastMonth = Number(yearSelected) < objectYear
                ? "Dec " + yearSelected
                : maxYearMonth;

            return item.displayText.toUpperCase() === currentLastMonth.toUpperCase();
        });

        const toDateOptions = getToDateOptionsWithMaxDate(tempFromDate?.[0]?.['displayText'], maxDateObject);
        setToDates(toDateOptions);

        if (capability === appNames.sustainability) { 
            setFromDateSelected(yearVal)
            localStorage.setItem('fromDateSelected_suppliers', JSON.stringify(yearVal))
        } else {
            setFromDateSelected(tempFromDate);
            localStorage.setItem('fromDateSelected_suppliers', JSON.stringify(tempFromDate))
        }
        dispatch(setKeyValue({ key: localStoreKeys.fromDateDisplayValue, value: tempFromDate?.[0]?.['displayText'] }));
        setToDateSelected(tempToDate);
        localStorage.setItem('toDateSelected_suppliers', JSON.stringify(tempToDate))
        const index = fromDate.findIndex((item) => item.displayText === tempToDate[0]?.displayText);
        if (index !== -1) {
            const tempFromDates = fromDate.slice(0, index + 1);
            setFromDates(tempFromDates);
        }
        if([appNames.resilinc,appNames.coman].includes(capability)) {
            onRoleChange(roleSelected);
        } else {
            /* Different Logic Required as Sustainability does not have Role field */
            resetForSustainability();
        }
    }
    
    const resetForSustainability = () => {
        const sectorsToSelect = getSectorsForSupplierFilters(userInfoByRole?.sector);
        setSectors(sectorsToSelect)
        setSectorSelected(sectorsToSelect)
        localStorage.setItem("sectorSelected_suppliers", JSON.stringify(sectors))

        
        const l1Categories = [...new Set(userInfoByRole?.l1)]?.map((str, index) => ({ displayText: str, id: index + 1 }));
        setCategoriesLevel1(l1Categories);
        setCategoryL1Selected(l1Categories);
        localStorage.setItem('categoryL1Selected_suppliers', JSON.stringify(l1Categories));

        loadSuppliersData()

    }
    
    const showWarningMessage = (message) => {
        showToast('warning', message, {
            icon: <Icon alt="" icon="warning_amber" size="medium" />
        });

    }

    
    const loadSuppliersData = (currentRole, sectors, BUs, categoryL0, categoryL1, categoryL2, fromDate, toDate) => {
        const sectorData = JSON.parse(localStorage.getItem("sectorSelected_suppliers"));  
        const buData = JSON.parse(localStorage.getItem("BUSeleceted_suppliers"));
        const categoryL0Data = JSON.parse(localStorage.getItem("CategoryL0Selected_suppliers"));
        const categoryL1Data = JSON.parse(localStorage.getItem("categoryL1Selected_suppliers"));
        const categoryL2Data = JSON.parse(localStorage.getItem("categoryL2Selected_suppliers")); 
        
            if(capability===appNames.resilinc) {
                // if(!(buData?.length>0 && categoryL2Data?.length>0 && sectorData?.length>0 && categoryL1Data?.length>0)) {
                //     message.warning("Please select required filters");

                // }
                    const requestObject = {
                        sector: sectorData?.map((item) => item.displayText ? item.displayText : item),
                        bu: buData?.map((item) => item.displayText ? item.displayText : item),
                        l0: categoryL0Data?.map((item) => item.displayText),
                        l1: categoryL1Data?.map((item) => item.displayText),
                        l2: categoryL2Data?.map((item) => item.displayText),
                    };
                    dispatch(FetchResilincFilterAction(requestObject));

            } else if(capability===appNames.coman) {
                // if(!(categoryL0Data?.length>0 && categoryL2Data?.length>0 && sectorData?.length>0 && categoryL1Data?.length>0)) {
                //     message.warning("Please select required filters");
                // }
                    const requestObject = {
                        sector: sectorData?.map((item) => item.displayText ? item.displayText : item),
                        l0: categoryL0Data?.map((item) => item.displayText),
                        l1: categoryL1Data?.map((item) => item.displayText),
                        l2: categoryL2Data?.map((item) => item.displayText),
                    };
                    dispatch(FetchSPMSupplierDetails(requestObject));
               

            } else if(capability===appNames.sustainability) {
                // if(!(sectorData?.length>0 && categoryL1Data?.length>0)){
                //     message.warning("Please select required filters");
                // }
                const requestObject = {
                    sector: sectorData?.map((item) => item.displayText ? item.displayText : item),
                    l1: categoryL1Data?.map((item) => item.displayText),
                };
                dispatch(FetchSustainabilitySupplierDetails(requestObject));

            }
        
    };

    
    const setBlankSuppliersAndCallBack = ()=>{
        
        setAllSuppliers([])
        setSuppliersSelected([])
        setAllRegens([])
        setRegenSelected([])
        localStorage.setItem('suppliersSelected_suppliers', JSON.stringify([]))
        localStorage.setItem('regenSelected_suppliers', JSON.stringify([]))
        message.warning("Please select required filters");
        setApiLoader(false);
        onParentCallback({ data: {}, loader: false })

    }
    
    
    // const loadKPIData = (currentRole, sectors, BUs, categoryL0, categoryL1, categoryL2, suppliers, fromDate, toDate) => {
    const loadKPIData = () => {
        const sectorsData = JSON.parse(localStorage.getItem("sectorSelected_suppliers"));  
        const BUsData = JSON.parse(localStorage.getItem("BUSeleceted_suppliers"));
        const categoryL0Data = JSON.parse(localStorage.getItem("CategoryL0Selected_suppliers"));
        const categoryL1Data = JSON.parse(localStorage.getItem("categoryL1Selected_suppliers"));
        const categoryL2Data = JSON.parse(localStorage.getItem("categoryL2Selected_suppliers"));
        const regenData = JSON.parse(localStorage.getItem("regenSelected_suppliers"));  
        const suppliersData = JSON.parse(localStorage.getItem("suppliersSelected_suppliers")); 
        const fromDateData = JSON.parse(localStorage.getItem("fromDateSelected_suppliers")); 
        const toDateData = JSON.parse(localStorage.getItem("toDateSelected_suppliers")); 
                
            if(capability===appNames.resilinc) {
                if(!(BUsData?.length>0 && categoryL2Data?.length>0 && sectorsData?.length>0 && categoryL1Data?.length>0 && suppliersData?.length>0)) {
                    message.warning("Please select required filters");
                }
                    const requestObject = {
                        supplier: suppliersData?.map((item) => item.displayText),
                        sector: sectorsData?.map((item) => item.displayText ? item.displayText : item),
                        bu: BUsData?.map((item) => item.displayText ? item.displayText : item),
                        l0: categoryL0Data?.map((item) => item.displayText),
                        l1: categoryL1Data?.map((item) => item.displayText),
                        l2: categoryL2Data?.map((item) => item.displayText),
                    };
                    dispatch(FetchResilincDetailAction(requestObject));

            } else if(capability===appNames.coman) {
                if(!(categoryL0Data?.length>0 && categoryL2Data?.length>0 && sectorsData?.length>0 && categoryL1Data?.length>0 && suppliersData?.length>0)) {
                    message.warning("Please select required filters");
                }
                    const requestObject = {
                        fromDate: fromDateData?.[0]?.value || '',
                        toDate: toDateData?.[0]?.value || '',
                        vendors: suppliersData?.map((item) => item.displayText),
                        sector: sectorsData?.map((item) => item.displayText ? item.displayText : item),
                        l0: categoryL0Data?.map((item) => item.displayText),
                        l1: categoryL1Data?.map((item) => item.displayText),
                        l2: categoryL2Data?.map((item) => item.displayText),
                    };
                    dispatch(FetchSupplierPerfInhouseDetail(requestObject));
            } else if(capability===appNames.sustainability) {
                if(!(sectorsData?.length>0 && categoryL1Data?.length>0 && suppliersData?.length>0)) {
                    message.warning("Please select required filters");

                }
                const requestObject = {
                    year: fromDateData?.[0]?.displayText || '',
                    supplier: suppliersData?.map((item) => item.displayText),
                    regens: regenData?.map((item) => item.displayText),
                    sector: sectorsData?.map((item) => item.displayText ? item.displayText : item),
                    l1: categoryL1Data?.map((item) => item.displayText),
                };
                dispatch(FetchSustainabilityAction(requestObject));
            }
          
    };
  
    
    const setBlankKPIDataAndCallBack = ()=>{
        
        message.warning("Please select required filters");
        setApiLoader(false);
        onParentCallback({ data: {}, loader: false })

    }

    
    return (
        <>
            <Row gutter={[10, 10]} justify="start" style={{ width: "100%" }}>
                {
                    [appNames.resilinc,appNames.coman].includes(capability) && 
                    <Col flex="1"> {/* xs={24} sm={24} md={3} lg={3} xl={3} */}
                        <SingleSelectDropdown placeholder="Views" className='buy-con-dropdown-modal ph-view-dropdown' label="View" childList={allRoles} selectedValue={roleSelected} setSelectedValue={onRoleChange} />
                    </Col>
                }
                <Col flex="1">
                    <MultiSelectDropdown placeholder="Sectors" className='buy-con-dropdown-modal' label="Sector" childList={sectors} selectedValue={sectorSelected} setSelectedValue={onSectorChange} />
                </Col>
                {
                    capability === appNames.resilinc && 
                    <Col flex="1">
                        <MultiSelectDropdown placeholder="BUs" className='buy-con-dropdown-modal' label="Business Unit / Market" childList={businessUnits} selectedValue={businessUnitSelected} setSelectedValue={onBusinessUnitChange} />
                    </Col>
                }
                {
                    [appNames.resilinc,appNames.coman].includes(capability) &&
                    <Col flex="1">
                        <MultiSelectDropdown placeholder="Categories L0" className='buy-con-dropdown-modal' label="Category L0" childList={categoriesLevel0} selectedValue={categoryL0Selected} setSelectedValue={onCategoryLevel0Change} />
                    </Col>
                }
                {
                    <Col flex="1">
                        <MultiSelectDropdown placeholder={capability===appNames.sustainability?"Category":"Categories L1"} className='buy-con-dropdown-modal' label={capability===appNames.sustainability?"Category":"Category L1"} childList={categoriesLevel1} selectedValue={categoryL1Selected} setSelectedValue={onCategoryLevel1Change} />
                    </Col>
                }
                {
                    [appNames.resilinc,appNames.coman].includes(capability) &&
                    <Col flex="1">
                        <MultiSelectDropdown placeholder={"Category L2"} className='buy-con-dropdown-modal' label="Category L2" childList={categoriesLevel2} selectedValue={categoryL2Selected} setSelectedValue={onCategoryLevel2Change} />
                    </Col>
                }
                {
                    [appNames.sustainability].includes(capability) &&
                    <Col flex="1">
                        <MultiSelectDropdown placeholder={"Supplier Type"} className='buy-con-dropdown-modal' label={"Supplier Type"} childList={allRegens} selectedValue={regenSelected} setSelectedValue={onRegenChange} />
                    </Col>
                }
                <Col flex="1">
                    <MultiSelectDropdown placeholder={capability===appNames.resilinc?"Tier 1 Suppliers":"Suppliers"} className='buy-con-dropdown-modal' label={capability===appNames.resilinc?"Tier 1 Supplier":"Supplier"} childList={allSuppliers} selectedValue={suppliersSelected} setSelectedValue={onSupplierChange} />
                </Col>
                {
                    capability !== appNames.resilinc && 
                    <Col flex="1">
                        {
                            capability === appNames.sustainability ?
                                <SingleSelectDropdown
                                    className='buy-con-dropdown-modal'
                                    label={"Year"}
                                    childList={landingPageFilters?.allYears}
                                    selectedValue={fromDateSelected}
                                    setSelectedValue={onFromDateChange}
                                />
                                :
                                <SingleSelectDropdown
                                    className='buy-con-dropdown-modal'
                                    label={"From Date"}
                                    childList={fromDates}
                                    selectedValue={fromDateSelected}
                                    setSelectedValue={onFromDateChange}
                                />
                        }
                    </Col>
                }
                {
                    capability === appNames.coman &&
                    <Col flex="1">
                        <SingleSelectDropdown className='buy-con-dropdown-modal' 
                            label="To Date" 
                            childList={toDates} 
                            selectedValue={toDateSelected} 
                            setSelectedValue={onToDateChange}
                            />
                    </Col>
                }
                
                
            </Row>
            <Row justify="end">
                    <button className="reset-button" onClick={onFiltersReset}  style={{ marginTop: '12px', marginRight:'0.8rem' }}>
                        <img src={reset_icon} className="reset_icon" alt="Reset Icon" />
                        <span style={{width: '100%'}}>Reset Filters</span>
                    </button>
            </Row>
        </>
    )

}


export default FilterWithSuppliers;